import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'animate.css'
import VueAnimateNumber from 'vue-animate-number'
//自定义指令 实现 图片懒加载 引入 全局注册
import lazy from '@/js/lazy'
Vue.directive('lazy', lazy)


Vue.use(VueAnimateNumber)
Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
